import { axiosInstance } from ".."

const showChatmemberlist = async (chatid) =>{
    return new Promise(async (resolve,reject)=>{
        axiosInstance.get(`internal/chat/members/${chatid}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default showChatmemberlist;